/* eslint-disable @typescript-eslint/no-explicit-any */

import * as React from "react";
import { TriggerActionCategory } from "~/client/resources/triggerResource";
import Triggers from "../../Triggers/Triggers";

export const RunbookTriggers: React.FC = (props: any) => {
    return <Triggers triggerActionCategory={TriggerActionCategory.Runbook} {...props} />;
};
